import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

const Home = lazy(() => import('./Home'));
const RatingPage = lazy(() => import('./RatingPage'));
const NewRecipe = lazy(() => import('./NewRecipe'));
const RecipeDetailPage = lazy(() => import('./RecipeDetailPage'));
const SignPage = lazy(() => import('./SignPage'));
const AccountSettings = lazy(() => import('./AccountSettings'));
const NotFound = lazy(() => import('./NotFound'));

export default function Router(props) {
  const { loggedIn, setLoggedIn } = props;

  return (
    <Switch>
      <Route exact path="/" component={Home} />
      <Route
        exact
        path="/mein-wochenplan"
        render={() => (
          <RatingPage loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
        )}
      />
      <Route
        exact
        path="/login"
        render={() => (
          <SignPage loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
        )}
      />
      <Route
        exact
        path="/einstellungen"
        render={() =>
          loggedIn ? (
            <AccountSettings loggedIn={loggedIn} setLoggedIn={setLoggedIn} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
      <Route exact path="/rezepte/neu" component={NewRecipe} />
      <Route
        exact
        path="/rezepte/:name"
        render={() => <RecipeDetailPage loggedIn={loggedIn} />}
      />
      <Route component={NotFound} />
    </Switch>
  );
}
